module.exports = __webpack_public_path__ + "img/LI.9b258f21.png";